var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.34316 0.343146V2.33719L9.24155 2.34426L0.636057 10.9497L2.05027 12.364L10.6558 3.75847L10.6628 11.6569H12.6569V0.343146H1.34316Z",
    fill: "#062229"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryarrow);
export default __webpack_public_path__ + "static/media/primaryarrow.8ed15fc61e0386e9d48f1253aa412713.svg";
export { ForwardRef as ReactComponent };